var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClientesAtivoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6217 26.1101C30.0539 26.7372 31.3408 27.6541 32.4012 28.8031C32.5619 28.9807 32.6533 29.2103 32.6586 29.4498V33.4095C32.6586 33.6721 32.5543 33.9239 32.3686 34.1095C32.183 34.2951 31.9312 34.3994 31.6687 34.3994H16.4899C16.2296 34.3995 15.9798 34.297 15.7946 34.1142C15.6093 33.9314 15.5035 33.683 15.5 33.4227V29.463C15.5021 29.219 15.5937 28.9841 15.7574 28.8031C16.8178 27.6541 18.1047 26.7372 19.5369 26.1101C20.9692 25.4829 22.5158 25.1592 24.0793 25.1592C25.6428 25.1592 27.1894 25.4829 28.6217 26.1101Z",
    fill: "#4D78AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0806 23.8388C26.6319 23.8388 28.7002 21.7706 28.7002 19.2192C28.7002 16.6679 26.6319 14.5996 24.0806 14.5996C21.5292 14.5996 19.4609 16.6679 19.4609 19.2192C19.4609 21.7706 21.5292 23.8388 24.0806 23.8388Z",
    fill: "#4D78AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClientesAtivoB);
export default __webpack_public_path__ + "static/media/IconClientesAtivoB.2f1226a42bec81a8a1e464914d365dcf.svg";
export { ForwardRef as ReactComponent };